import {gsap} from "../LibrariesImport";

export default class SliderGrab {
    static init() {
        let sliders = document.querySelectorAll('.slider-grab .swiper');
        this.allSliders = [];

        sliders.forEach((slider) => {
            this.slider(slider);
        });
    }

    static slider(slider) {

        const btnConfig = {duration: 0.5, ease: "power2.out"};
        const prev = slider.querySelector('.prev');
        const next = slider.querySelector('.next');
        const arrows = slider.querySelector(".arrows");

        if (arrows) {
            const svg = arrows.querySelector("svg");
            this.moveBtnPosition = {
                top: gsap.quickTo(arrows, "top", btnConfig),
                left: gsap.quickTo(arrows, "left", btnConfig),
                rotate: gsap.quickTo(svg, "rotation", btnConfig)
            };
        }

        const myswiper = new Swiper(slider, {
            loop: false,
            slidesPerView: "auto",
            spaceBetween: 20,
            speed: 700,
            pagination: {
                el: slider.querySelector('.slider-cards-pagination'),
                type: 'bullets',
                clickable: true,
                dynamicBullets: false,
            },
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            touchEventsTarget: "container",
            mousewheel: {
                enabled: true,
                releaseOnEdges: true,
                forceToAxis: true,
            },
            on: {
                touchStart: () => {
                    gsap.to(arrows, 0.2, {
                        scale: 0.2,
                    });
                },
                touchMove: (swiper, e) => {
                    const blockOffset = slider.getBoundingClientRect();

                    if (arrows) {
                        this.moveBtnPosition.top(e.clientY - blockOffset.top);
                        this.moveBtnPosition.left(e.clientX - blockOffset.left);
                    }
                },
                touchEnd: () => {
                    if (arrows) {
                        gsap.to(arrows, 0.2, {
                            scale: 1,
                        });
                    }
                },
                lock: () => {
                    slider.classList.remove("swiper-is-active");
                },
                unlock: () => {
                    slider.classList.add("swiper-is-active");
                }
            }
        });


        if (arrows) {
            myswiper.arrows = arrows;
            this.allSliders.push(myswiper);

            slider.addEventListener("mouseenter", (e) => {
                const blockOffset = slider.getBoundingClientRect();

                gsap.to(arrows, {
                    scale: 1,
                    opacity: 1,
                    duration: 0.3
                });

                this.moveBtnPosition.top(e.clientY - blockOffset.top);
                this.moveBtnPosition.left(e.clientX - blockOffset.left);
            });

            slider.addEventListener("mousemove", (e) => {
                const blockOffset = slider.getBoundingClientRect();
                const xPos = (e.clientX - blockOffset.left) / blockOffset.width;
                const rotation = (xPos * 40) - 20;

                this.moveBtnPosition.top(e.clientY - blockOffset.top);
                this.moveBtnPosition.left(e.clientX - blockOffset.left);
                this.moveBtnPosition.rotate(rotation);
            });

            slider.addEventListener("mouseleave", () => {
                gsap.to(arrows, {
                    scale: 0.5,
                    opacity: 0,
                    duration: 0.3
                });
            });
        }
    }
}
